import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";

export default function numberZodSchema({ required }: FormInputSchemaParams) {
	return z.any().superRefine((value, ctx) => {
		if (value === null || value === undefined || value === "") {
			if (required) {
				ctx.addIssue({ code: "custom", message: "required" });
			}
			return;
		}

		const result = z.number({ message: "invalidNumber" }).safeParse(value);
		if (!result.success) {
			ctx.addIssue({ code: "custom", message: "invalidNumber" });
		}
	});
}
